import { render, staticRenderFns } from "./EvaluationDocuments.vue?vue&type=template&id=61123aa1&scoped=true"
import script from "./EvaluationDocuments.vue?vue&type=script&lang=js"
export * from "./EvaluationDocuments.vue?vue&type=script&lang=js"
import style0 from "./EvaluationDocuments.vue?vue&type=style&index=0&id=61123aa1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61123aa1",
  null
  
)

export default component.exports